import {
  call, put, fork, takeLatest,
} from 'redux-saga/effects'
import * as UserApi from '../../api/user'
import {
  FETCH_ME_FAILURE,
  FETCH_ME_REQUEST,
  FETCH_ME_SUCCESS,
  FETCH_CREDIT_CARD_REQUEST,
  FETCH_CREDIT_CARD_SUCCESS,
  FETCH_CREDIT_CARD_FAILURE,
  ADD_CREDIT_CARD_REQUEST,
  ADD_CREDIT_CARD_SUCCESS,
  ADD_CREDIT_CARD_FAILURE,
  FETCH_WALLET_RECORDS_REQUEST,
  FETCH_WALLET_RECORDS_SUCCESS,
  FETCH_WALLET_RECORDS_FAILURE,
  FETCH_WALLET_RECORDS_END,
  ADD_WALLET_VALUE_REQUEST,
  ADD_WALLET_VALUE_SUCCESS,
  ADD_WALLET_VALUE_FAILURE,
} from '../../actions/user'
import { addError } from '../../actions/notifications'

export function* fetchMe() {
  try {
    const res = yield call(UserApi.fetchMe)
    yield put({
      type: FETCH_ME_SUCCESS,
      user: res.user,
    })
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: FETCH_ME_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchMe() {
  yield takeLatest(FETCH_ME_REQUEST, fetchMe)
}

export function* fetchCreditCards() {
  try {
    const res = yield call(UserApi.fetchCreditCards)
    yield put({
      type: FETCH_CREDIT_CARD_SUCCESS,
      creditCards: res.cards,
    })
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: FETCH_CREDIT_CARD_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchCreditCards() {
  yield takeLatest(FETCH_CREDIT_CARD_REQUEST, fetchCreditCards)
}

export function* addCreditCard({ cardToken }) {
  try {
    const res = yield call(UserApi.addCreditCard, cardToken)
    yield put({
      type: ADD_CREDIT_CARD_SUCCESS,
      creditCard: res.card,
    })
    // yield put(addSuccess('Add Credit Card Success'))
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: ADD_CREDIT_CARD_FAILURE,
      error: err.message,
    })
  }
}

export function* watchAddCreditCard() {
  yield takeLatest(ADD_CREDIT_CARD_REQUEST, addCreditCard)
}

export function* fetchWalletRecords({ offset = 0 }) {
  try {
    const res = yield call(UserApi.fetchWalletRecords, offset)
    yield put({
      type: FETCH_WALLET_RECORDS_SUCCESS,
      walletRecords: res.wallet_records,
      offset,
    })
    if (res.wallet_records && res.wallet_records.length === 0) {
      yield put({
        type: FETCH_WALLET_RECORDS_END,
      })
    }
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: FETCH_WALLET_RECORDS_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchWalletRecords() {
  yield takeLatest(FETCH_WALLET_RECORDS_REQUEST, fetchWalletRecords)
}

export function* addWalletValue({ cardId, amount }) {
  try {
    const res = yield call(UserApi.addWalletValue, cardId, amount)
    yield put({
      type: ADD_WALLET_VALUE_SUCCESS,
      walletBalance: res.wallet_balance,
    })
    // yield put(addSuccess('Add Value Success'))
  } catch (err) {
    yield put(addError(err.message))
    yield put({
      type: ADD_WALLET_VALUE_FAILURE,
      error: err.message,
    })
  }
}

export function* watchAddWalletValue() {
  yield takeLatest(ADD_WALLET_VALUE_REQUEST, addWalletValue)
}

export default [
  fork(watchFetchMe),
  fork(watchFetchCreditCards),
  fork(watchAddCreditCard),
  fork(watchFetchWalletRecords),
  fork(watchAddWalletValue),
]
